import { useSelector } from 'react-redux';
import {
  authInProgressSelector,
  userNameSelector,
} from 'redux/modules/auth/selectors';
import useVerifyEmailModalDispatch from './useVerifyEmailModalDispatch';

export default () => {
  const email = useSelector(userNameSelector);
  const loading = useSelector(authInProgressSelector);
  const { onChangeEmail, onResendEmail } = useVerifyEmailModalDispatch();

  return {
    email,
    loading,
    onChangeEmail,
    onResendEmail: () => onResendEmail(email),
  };
};
